'use client';

import { Root } from '@radix-ui/react-aspect-ratio';

import type { ComponentProps, JSX } from 'react';

export function AspectRatio(props: ComponentProps<typeof Root>): JSX.Element {
  return <Root data-slot='aspect-ratio' {...props} />;
}
